import { getDRMToken, getManifest } from 'store/actions/content';
import { useEffect, useState } from 'react'
import useSession from './useSession';

const useDRM = (uuid, hasDRM) => {
  
  const { isLoggedIn } = useSession();

  const [manifest, setCountDown] = useState("");
  const [token, setToken] = useState("");
  
  const getManifestURL = async () => {
    try {
      const response = await getManifest(uuid, "widevine");
      setCountDown(response.payload);
    } catch (e) {
      console.log("error getManifest", e)
    }
  };

  const getToken = async () => {
    try {
      const response = await getDRMToken(uuid, 'Widevine');
      setToken(response.payload.token);
    } catch (e) {
      console.log("error getToken", e)
    }
  };

  useEffect(() => {
    if (!isLoggedIn || !hasDRM ) return

    getManifestURL();
    getToken();

    // eslint-disable-next-line
  }, []);

  return { manifest, token };
};

export default useDRM;